<template>
<div class="menu-list monitor">
    <card class="mb-5">
        <template slot="header">
            <div class="flex ai-c jc-sb">
                <div class="flex-33">
                    <i class="material-icons">assignment</i>
                    <strong class="ml-2">Facility Management</strong>
                </div>

                <div class="flex-33">
                    <i class="material-icons">insert_chart</i>
                    <strong class="ml-2">Cycle Management</strong>
                </div>

                <div class="flex-33">
                    <i class="material-icons">insert_chart</i>
                    <strong class="ml-2">Tenant &amp; User Management</strong>
                </div>
            </div>
        </template>

        <template slot="body">
            <div class="flex jc-sb">
                <div class="flex-33 mr-2">
                    <router-link class="button" to="/add-facility">Add Facility</router-link>

                    <p class="mt-2">Create a new facility.</p>
                </div>

                <div class="flex-33 ml-2 mr-2">
                    <router-link class="button" to="/manage-cycles">Manage Cycles</router-link>

                    <p class="mt-2">Create a cycle, update a cycle, or upload tenants to a cycle.</p>
                </div>

                <div class="flex-33 ml-2">
                    <router-link class="button" to="/tenant-list">Master Tenants List</router-link>

                    <p class="mt-2">Show all tenants in the program.</p>
                </div>
            </div>

            <div class="flex jc-sb mt-5">
                <div class="flex-33 mr-2">
                    <router-link class="button" to="/list-facilities">View Facilities</router-link>

                    <p class="mt-2">Show a list of all facilities.</p>
                </div>

                <div class="flex-33 ml-2 mr-2">
                    <router-link class="button" to="/send-letters">Send Proof Letters</router-link>

                    <p class="mt-2">Generate and download proof letters for the cycle.</p>
                </div>

                <div class="flex-33 ml-2">
                    <router-link class="button" to="/manage-users">View User Accounts</router-link>

                    <p class="mt-2">Show a list of all user accounts.</p>
                </div>
            </div>

            <div class="flex jc-sb mt-5">
                <div class="flex-33 mr-2">
                </div>

                <div class="flex-33 ml-2 mr-2">
                </div>

                <div class="flex-33 ml-2">
                    <router-link class="button" to="/insurance-policy-management">Insurance Policy Management</router-link>

                    <p class="mt-2">Manage tenants that can be setup for insurance policies.</p>
                </div>
            </div>

            <hr />

            <div class="flex jc-sb">
                <div class="flex-33 mr-2">
                    <div>
                        <i class="material-icons">insert_chart</i>
                        <strong class="ml-2">Move-Out Stats</strong>
                    </div>

                    <div class="mt-3">
                        <loading-wrapper :loading="isLoadingStats">
                            <div class="stat-item">
                                <label class="label">Move-Outs In Progress</label>
                                <span v-if="stats.move_outs === undefined || stats.move_outs.doing_move_outs === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.move_outs.doing_move_outs.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=doing_move_outs" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <div class="stat-item">
                                <label class="label">Confirmed Move-Outs</label>
                                <span v-if="stats.move_outs === undefined || stats.move_outs.confirmed_move_outs === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.move_outs.confirmed_move_outs.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=confirmed_move_outs" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <div class="stat-item">
                                <label class="label">Confirmed No Move-Outs</label>
                                <span v-if="stats.move_outs === undefined || stats.move_outs.confirmed_no_move_outs === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.move_outs.confirmed_no_move_outs.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=confirmed_no_move_outs" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <hr class="small" />

                            <div class="stat-item">
                                <label class="label">Total Cycles</label>
                                <span v-if="stats.move_outs === undefined || stats.move_outs.total === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <strong>{{ stats.move_outs.total.toLocaleString() }}</strong>
                                    <router-link to="/manage-cycles" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>
                        </loading-wrapper>
                    </div>
                </div>

                <div class="flex-33 ml-2 mr-2">
                    <div>
                        <i class="material-icons">insert_chart</i>
                        <strong class="ml-2">Tenant Threshold Stats</strong>
                    </div>

                    <div class="mt-3">
                        <loading-wrapper :loading="isLoadingStats">
                            <div class="stat-item">
                                <label class="label">Opt-Outs > 5%</label>
                                <span v-if="stats.tenant_thresholds === undefined || stats.tenant_thresholds.opt_outs_threshold === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.tenant_thresholds.opt_outs_threshold.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=opt_outs_threshold" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <div class="stat-item">
                                <label class="label">Provided Proof > 20%</label>
                                <span v-if="stats.tenant_thresholds === undefined || stats.tenant_thresholds.provided_proof_threshold === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.tenant_thresholds.provided_proof_threshold.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=provided_proof_threshold" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <div class="stat-item">
                                <label class="label">Bad Address > 5%</label>
                                <span v-if="stats.tenant_thresholds === undefined || stats.tenant_thresholds.bad_address_threshold === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.tenant_thresholds.bad_address_threshold.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=bad_address_threshold" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>

                            <div class="stat-item">
                                <label class="label">Moved Outs > 5%</label>
                                <span v-if="stats.tenant_thresholds === undefined || stats.tenant_thresholds.moved_out_threshold === undefined" class="blank-stat">9,999</span>
                                <span v-else>
                                    <span>{{ stats.tenant_thresholds.moved_out_threshold.toLocaleString() }}</span>
                                    <router-link to="/manage-cycles?filter=moved_out_threshold" class="button small ml-3">
                                        <i class="material-icons">open_in_new</i>
                                    </router-link>
                                </span>
                            </div>
                        </loading-wrapper>
                    </div>
                </div>

                <div class="flex-33 ml-2"></div>
            </div>
        </template>
    </card>
</div>
</template>

<script>
import http from "@/http"
import store from "@/store"

export default {
    data () {
        return {
            activeStatTab: "plain",
            isLoadingStats: false,
            stats: {}
        }
    },

    computed: {
        chartData () {
            const data = []

            if (this.stats.doing_move_outs !== undefined) {
                const value = this.stats.doing_move_outs

                data.push({ value, name: `Doing Move-Outs (${value})` })
            }

            if (this.stats.confirmed_move_outs !== undefined) {
                const value = this.stats.confirmed_move_outs

                data.push({ value, name: `Confirmed Move-Outs (${value})` })
            }

            if (this.stats.confirmed_no_move_outs !== undefined) {
                const value = this.stats.confirmed_no_move_outs

                data.push({ value, name: `Confirmed No Move-Outs (${value})` })
            }

            return data
        },

        chartOptions () {
            return {
                color: ["#7ed5ad", "#8b50ff", "#41a6fc"],
                series: [
                    {
                        name: "Dataset",
                        type: "pie",
                        radius: "60%",
                        center: ["50%", "50%"],
                        data: this.chartData,
                        roseType: "radius",
                        label: {
                            normal: {
                                textStyle: { color: "#555555" }
                            }
                        },
                        labelLine: {
                            normal: {
                                lineStyle: { color: "#555555" },
                                smooth: 0.2,
                                length: 10,
                                length2: 20
                            }
                        },
                        itemStyle: {
                            normal: {
                                shadowBlur: 200,
                                shadowColor: "rgba(0, 0, 0, 0.25)"
                            }
                        },
                        animationType: "scale",
                        animationEasing: "elasticOut",
                        animationDelay: function (idx) {
                            return Math.random() * 200
                        }
                    }
                ]
            }
        },

        isAdmin () {
            return store.getters.hasPermissions(["admin"])
        }
    },

    mounted () {
        this.getStats()
    },

    methods: {
        async getStats () {
            this.isLoadingStats = true

            try {
                const { data: stats } = await http("/api/monitors/cycle-stats")

                this.stats = stats
            } catch (ex) {
                if (ex.message) {
                    this.$eventManager.emit("add-toast", { message: ex.message, type: "error" })
                } else {
                    this.$eventManager.emit("add-toast", { message: ex, type: "error" })
                }
            } finally {
                this.isLoadingStats = false
            }
        }
    }
}
</script>

<style scoped>
.chart /deep/ .echarts {
    height: auto !important;
    width: 100% !important;
}

.chart /deep/ .echarts > div {
    height: auto !important;
    padding-top: 66.6666% !important;
    width: 100% !important;
}

.chart /deep/ .echarts canvas {
    height: auto !important;
    width: 100% !important;
}

.stat-item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 6px;
}

.stat-item .label {
    flex: 1 1 50%;
    margin: 0;
}

.stat-item .blank-stat,
.stat-item .stat {
    flex: 0;
}

.stat-item .blank-stat {
    background: #ececec;
    border-radius: 2px;
    color: #ececec;
}
</style>



// WEBPACK FOOTER //
// src/components/home-page/MonitorMenuList.vue